import { FC } from 'react';
import { twJoin } from 'tailwind-merge';

import { DbtResourceIcon, ResourceTypeExplorer } from '@dbt-labs/dbt-dag';

import { FilterState } from '@/context/FilterProvider';
import { pluralizeResourceType } from '@/util/resourceType';
import { BaseFilterToggle, FilterToggleProps } from './BaseFilterToggle';

interface ResourceFilterToggleProps extends FilterToggleProps {
  resourceType: ResourceTypeExplorer;
  onToggle: FilterState['updateFilters'];
  onDive?: (resourceType: ResourceTypeExplorer) => void;
  count?: number;
}

export const ResourceFilterToggle: FC<ResourceFilterToggleProps> = (props) => {
  const { resourceType, isChecked, count } = props;

  const onToggle = () => {
    if (resourceType === 'column') {
      props.onToggle({ column: true }, !isChecked);
    } else {
      props.onToggle({ resourceType: [resourceType] }, !isChecked);
    }
  };

  const onDive =
    resourceType === 'model' && props.onDive
      ? () => {
          props.onDive?.(resourceType);
        }
      : undefined;

  return (
    <BaseFilterToggle
      {...props}
      onToggle={onToggle}
      onDive={onDive}
      checkBoxTestId={`${resourceType}-filter-checkbox`}
      count={count}
    >
      <DbtResourceIcon
        resource={resourceType}
        size="xs"
        className={twJoin(
          'flex-0',
          isChecked && 'text-fgMain',
          !isChecked && 'text-fgDecorative',
        )}
      />
      <span className="flex-1">{pluralizeResourceType(resourceType, true)}</span>
    </BaseFilterToggle>
  );
};
